/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubjectDTO,
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
} from './SubjectDTO';

/**
 * 
 * @export
 * @interface SubjectDTOPagedResponse
 */
export interface SubjectDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SubjectDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof SubjectDTOPagedResponse
     */
    data?: Array<SubjectDTO> | null;
}

export function SubjectDTOPagedResponseFromJSON(json: any): SubjectDTOPagedResponse {
    return SubjectDTOPagedResponseFromJSONTyped(json, false);
}

export function SubjectDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(SubjectDTOFromJSON)),
    };
}

export function SubjectDTOPagedResponseToJSON(value?: SubjectDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(SubjectDTOToJSON)),
    };
}

